import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import {Box, Tooltip, Typography} from '@mui/material';
import {resourceIcon} from '../../../utils/resource-icons';
import {getSingularResourceLabel} from '../../../utils/resource-utils';
import TabItem from '../../../@types/tab-item';

interface TabLabelProps {
    tab: TabItem;
    isActive: boolean;
    onClose?: (event: React.SyntheticEvent) => void;
}

/**
 * TabLabel component renders the content of a tab including icon, label, and close button
 */
export const TabLabel: React.FC<TabLabelProps> = ({ tab, isActive, onClose }) => {
    return (
        <Tooltip title={`${getSingularResourceLabel(tab.type)}: ${tab.label}`} enterDelay={500}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    gap: '4px',
                    '& .close-icon': {
                        opacity: isActive ? 1 : 0,
                        transition: 'opacity 0.15s',
                    },
                    '&:hover .close-icon': {
                        opacity: 1,
                    },
                }}
            >
                {resourceIcon(tab.type)}
                <Typography
                    variant="body2"
                    sx={{
                        flexGrow: 1,
                        textTransform: 'none',
                        textAlign: 'left',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '150px',
                    }}
                >
                    {tab.label}
                </Typography>
                <CloseIcon
                    className="close-icon"
                    sx={{
                        width: 16,
                        height: 16,
                        flexShrink: 0,
                        borderRadius: '4px',
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.1)',
                        },
                    }}
                    onClick={onClose}
                />
            </Box>
        </Tooltip>
    );
};